import React, { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Modal, SettingsLoginForm } from "../../components";

import "../../styles/components/modals/_change-password.scss";
import { useLocation, useNavigate } from "react-router-dom";
import {
  setModalLoginFormClosed,
  setModalLoginFormOpen,
} from "../../actions/modals";

function LoginModal() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { userId } = useSelector((state) => state.session);
  const { LoginFormOpen, resetPassword } = useSelector((state) => state.modals);

  const isAuthed = useMemo(() => !!userId, [userId]);

  useEffect(() => {
    if (location?.hash === "#login") {
      dispatch(setModalLoginFormOpen());
    }
    if (location?.pathname.includes("/reports") && !isAuthed) {

      window.location.replace(
        `${process.env.REACT_APP_API_URL}/oauth/azure?redirect=${location.pathname}`
      );
    }
  }, [location, isAuthed, navigate, dispatch]);

  const handleClose = useCallback(() => {
    dispatch(setModalLoginFormClosed());
  }, [dispatch]);

  return (
    <Modal isOpen={LoginFormOpen} modalName="login-modal" onClose={handleClose}>
      <SettingsLoginForm
        onClose={handleClose}
        isForgotPassword={resetPassword}
      />
    </Modal>
  );
}

export default LoginModal;
